import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoaderServiceService } from './loader-service.service';


interface AddressComponent {
  long_name: string;
  short_name: string;
  types: string[];
}

interface GeocodeResult {
  results: any
}

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  private readonly API_KEY = 'AIzaSyDX8co0kvPufyqJvaTCYN0ge4PTCAtjrAk';

  constructor(private http: HttpClient,private ls:LoaderServiceService) {}

  async getCurrentLocation(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      if ('geolocation' in navigator) {

        navigator.geolocation.getCurrentPosition(
          async position => {
            // this.ls.showLoader = true
            const { latitude, longitude } = position.coords;
            try {
              const locationInfo = await this.getLocationInfo(latitude, longitude);
              resolve({ latitude, longitude, ...locationInfo });
            } catch (error) {
              reject('Error getting location info');
            }
          },
          error => reject(error)
        );
      } else {
        reject('Geolocation is not supported by your browser.');
      }
    });
  }

  private async getLocationInfo(latitude: number, longitude: number): Promise<any> {
    const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${this.API_KEY}`;
    try {
      const response = await this.http.get<GeocodeResult>(apiUrl).toPromise();
      console.log(response);
      
      const addressComponents = response.results[0].address_components;
      const formattedAddress = response.results[0].formatted_address;

      // Extract city, state, and country from address components
      const city = this.extractAddressComponent(addressComponents, 'locality');
      const state = this.extractAddressComponent(addressComponents, 'administrative_area_level_1');
      const country = this.extractAddressComponent(addressComponents, 'country');
      const sublocality_level_1 = this.extractAddressComponent(addressComponents, 'sublocality_level_1');

      return { city, state, country, sublocality_level_1, formattedAddress };
    } catch (error) {
      throw error;
    }
  }

  private extractAddressComponent(addressComponents: AddressComponent[], type: string): string {
    const component = addressComponents.find(component => component.types.includes(type));
    return component ? component.long_name : '';
  }
}
